import { Col, Form, Row, Select } from "antd";
import React, { useEffect, useState } from "react";

import { getOptions } from "../../../helpers/options";
import { getAllEstablishmentCategory } from "../../http-request/establishment";
import CategoryForm from "./categoryForm";

const EstablishmentCategory = () => {
  const [categories, setcategories] = useState();
  const getCategories = async () => {
    await getAllEstablishmentCategory().then(({ categories }) => {
      let _categories = getOptions({
        data: categories,
        value: "_id",
        label: "category",
      });
      setcategories(_categories);
    });
  };

  useEffect(() => {
    getCategories();
  }, []);

  return (
    <Row>
      <Col span={24}>
        <Form.Item
          labelAlign="left"
          name="category"
          label="Category"
          rules={[
            {
              required: true,
              message: "Please select establishment category!",
            },
          ]}
        >
          <Select
            allowClear
            options={categories}
            placeholder="Select Category ... "
            dropdownRender={(menu) => {
              return (
                <>
                  {menu}
                  <CategoryForm
                    categories={categories}
                    reloadCategories={getCategories}
                  />
                </>
              );
            }}
          ></Select>
        </Form.Item>
      </Col>
    </Row>
  );
};

export default EstablishmentCategory;
